import { isMobileTeamViewport, resolveTeamTasksAppUrl } from "./teamNavigation";
import { appNavigate } from "./appNavigateBridge";
import { openWindowWithTabAuth } from "./tabAuthStorage";

/**
 * Abre um painel de tarefas em janela dedicada (sem topo/menu do Xpro).
 * No mobile, navega para /equipe/tarefas dentro do app principal.
 */
export function buildTeamTasksPopupUrl({ boardId, leadId, spaceId, inbox, scope, cardId } = {}) {
  let url = "/popup-equipe/tarefas";
  if (inbox) {
    url = "/popup-equipe/tarefas/inbox";
    if (scope === "team" || scope === "created" || scope === "analytics") {
      url += `?scope=${encodeURIComponent(scope)}`;
    }
  } else if (leadId != null) {
    url = `/popup-equipe/tarefas/lead/${encodeURIComponent(String(leadId))}`;
  } else if (spaceId != null) {
    url = `/popup-equipe/tarefas/space/${encodeURIComponent(String(spaceId))}`;
  } else if (boardId != null) {
    url = `/popup-equipe/tarefas/${encodeURIComponent(String(boardId))}`;
  }

  if (cardId != null && Number(cardId) > 0 && !inbox) {
    const sep = url.includes("?") ? "&" : "?";
    url += `${sep}card=${encodeURIComponent(String(cardId))}`;
  }
  return url;
}

export function openTeamTasksPopupWindow({ boardId, leadId, spaceId, inbox, scope, cardId } = {}) {
  if (isMobileTeamViewport()) {
    appNavigate(
      resolveTeamTasksAppUrl({ boardId, leadId, spaceId, inbox, scope, cardId })
    );
    return null;
  }

  const url = buildTeamTasksPopupUrl({ boardId, leadId, spaceId, inbox, scope, cardId });

  const width = window.screen.availWidth || window.screen.width;
  const height = window.screen.availHeight || window.screen.height;

  return openWindowWithTabAuth(
    url,
    "TeamTasksPopup",
    `width=${width},height=${height},top=0,left=0,scrollbars=no,toolbar=no,location=no,status=no,menubar=no`
  );
}
